@if (isMapAvailable) {
    <div class="ng-label">{{ messages.hotelOnMap }}</div>
    <div class="ng-toggle-map">
        <button class="btn ng-toggle-map-btn" type="button" (click)="toggleMap()">
            {{ mapBtnLabel }}
        </button>
    </div>
}
